import styled from 'styled-components';

export const Card = styled.div`
  border-radius: 15px;
  margin: 10px;
  padding: 10px 15px;
  background-color: var(--white);
  box-shadow: 7px 7px 20px -10px rgba(0, 0, 0, 0.4);
`;
